export class BasicRequest {
    public agentID?: string;
    public unitProfileID?: string;
    public apiVersion?: string;
    public clientSoftwareVersion?: string;
}